import CaptchaBox from './src/main.js'
export default CaptchaBox



// WEBPACK FOOTER //
// ./src/components/Captcha/index.js